<template>
  <section class="relative overflow-hidden bg-white py-20 md:py-28">
    <div class="paw-pattern pointer-events-none absolute inset-0 opacity-[0.35]" aria-hidden="true" />
    <div class="relative mx-auto max-w-6xl px-4 text-center md:px-6">
      <h2 class="text-4xl font-bold leading-[1.05] tracking-tight text-foreground md:text-5xl lg:text-6xl">
        {{ $ts('finalCta.title') }}
      </h2>
      <p class="mx-auto mt-4 max-w-lg text-lg text-muted-foreground">
        {{ $ts('finalCta.subtitle') }}
      </p>
      <NuxtLink :to="$localeRoute('/vet/signup')">
        <button class="mt-10 inline-flex h-14 items-center gap-2 rounded-full bg-foreground px-10 text-base font-semibold text-background transition-opacity hover:opacity-80">
          {{ $ts('finalCta.cta') }}
          <Icon name="tabler:arrow-right" size="18" />
        </button>
      </NuxtLink>
      <p class="mt-5 text-sm text-muted-foreground">{{ $ts('finalCta.note') }}</p>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from '#imports';

const { $ts, $localeRoute } = useI18n();
</script>
